export default __webpack_public_path__ + "static/media/unordered_list_icon_white.ccd876cf.svg";